import { FormValidationSchema } from "@/components/Form/types";
import { I_ResetPasswordPage } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";

export const buildPasswordValidationRules = (
  data: I_ResetPasswordPage,
  password: string
): FormValidationSchema[] => [
  {
    name: "password",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("password", "required", data),
      },
      pattern: {
        value: /(?!.*\s)(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,33}$/,
        message: getRuleErrorMessage("password", "pattern", data),
      },
    },
  },
  {
    name: "repeatPassword",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("repeatPassword", "required", data),
      },
      validate: (value) => {
        return value === password || getRuleErrorMessage("repeatPassword", "validate", data);
      },
    },
  },
];
